import { NgModule } from '@angular/core';
import { importExportTranslationChunksConfig, importExportTranslationsEn } from '@spartacus/cart/import-export/assets';
import { CART_IMPORT_EXPORT_FEATURE } from '@spartacus/cart/import-export/root';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { CustomImportExportRootModule } from './import-export/root/import-export-root.module';

@NgModule({
  declarations: [],
  imports: [CustomImportExportRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CART_IMPORT_EXPORT_FEATURE]: {
          module: () => import('./import-export/import-export.module').then(m => m.CustomImportExportModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: importExportTranslationsEn },
        chunks: importExportTranslationChunksConfig,
      },
    }),
  ],
})
export class CartImportExportFeatureModule {}
